import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import { noTextOverflow } from 'utils/styleUtils'

const entireHeight = 270
const thumbHeight = '50%'

const styles = (theme) => ({
  root: {
    position: 'relative',
    height: entireHeight,
    padding: 10,
    border: `1px solid ${theme.palette.primary.main}`,
    overflow: 'hidden'
  },
  title: {
    padding: 6,
    color: theme.palette.primary.dark,
    fontWeight: 500,
    ...noTextOverflow({ '&:hover': null }),
  },
  thumbnailWrapper: {
    width: 150,
    height: thumbHeight,
    margin: 'auto',
  },
  thumbnail: {
    width: '100%',
    height: '100%',
    objectFit: 'scale-down',
  },
  additionalInfo: {
    padding: 6,
    height: 57,
    overflow: 'hidden',
  },
  customerAttns: {
    minHeight: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  hot: {
    color: theme.palette.accent.noticeLight,
    fontWeight: 500,
    margin: '0 6px',
  },
  buyNowButton: {
    background: theme.palette.primary.main,
    color: '#fff',
    transition: 'background 0.6s, color 0.6s',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
})

const SupplementCard = ({
  classes,
  productUrl,
  title,
  saleRank,
  thumbnailUrl,
  additionalInfo,
}) => {
  return (
    <div className={classes.root}>
      <Typography
        component="a"
        href={productUrl}
        target="_blank"
        align="center"
        classes={{ root: classes.title }}
      >
        {title}
      </Typography>
      <div className={classes.thumbnailWrapper}>
        <img
          className={classes.thumbnail}
          src={thumbnailUrl}
          alt={title}
          title={title}
        />
      </div>
      <Typography
        classes={{ root: classes.additionalInfo }}
        align="center"
        variant="caption"
      >
        {additionalInfo || title}
      </Typography>
      <div className={classes.customerAttns}>
        <Typography variant="caption" classes={{ root: classes.hot }}>
          {saleRank < 2000 ? 'HOT' : ''}
        </Typography>
        <a href={productUrl} target="_blank">
          <Button
            variant="raised"
            size="small"
            classes={{ root: classes.buyNowButton }}
          >
            Check Price
          </Button>
        </a>
      </div>
    </div>
  )
}

export default withStyles(styles)(SupplementCard)



// WEBPACK FOOTER //
// ./src/components/supplements/SupplementCard.js